<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader">
        <div class="headerCon acea-row row-center-wrapper">
          <div>
            <div class="name">医生列表</div>
          </div>
        </div>
      </div>
      <div class="nav acea-row row-around">
        <div
          class="item"
          :class="screen.type == 1 ? 'on' : ''"
          @click="checkGrade(1)"
        >
          审核通过
        </div>
        <div
          class="item"
          :class="screen.type == 2 ? 'on' : ''"
          @click="checkGrade(2)"
        >
          审核未通过
        </div>
      </div>
    </div>
    <div class="list">
      <div :class="fixedState === true ? 'sortList' : ''">
        <div
          class="item"
          v-for="(val, index) in spreadList"
          :key="index"
          :style="
            val.certification_type == '醫生'
              ? 'background-color:#ff000075;'
              : ''
          "
        >
          <div class="person " @click="changUrl(val)">
            <div class="person-top acea-row row-between-wrapper">
              <div class="picTxt acea-row row-between-wrapper">
                <div class="pictrue"><img :src="val.avatar" /></div>
                <div class="text">
                  <div class="name line1">
                    {{ val.nickname }}
                  </div>
                  <div>联系方式: {{ val.phone }}</div>
                </div>
              </div>
              <div
                class="no-pass"
                v-if="screen.type == 1"
                @click="doOpenConfirm(val.uid)"
              >
                更改审核状态
              </div>
              <div
                class="do-pass"
                v-else-if="screen.type == 2"
                @click="doOpenConfirm(val.uid)"
              >
                更改审核状态
              </div>
            </div>
            <div class="person-bottom">
              <div class="person-bottom-item">所在医院:{{ val.hospital }}</div>
              <div class="person-bottom-item">
                所属部门:{{ val.department }}
              </div>
              <div class="person-bottom-item">职位:{{ val.position }}</div>
              <div class="person-bottom-item">
                上级名称:{{ val.spread_nickname }}
              </div>
              <div class="person-bottom-item">
                上级编号:{{ val.spread_uid }}
              </div>
              <div class="person-bottom-item">
                审核状态:{{ screen.type == 1 ? "审核通过" : "审核未通过" }}
              </div>
            </div>
            <!-- <div v-if="val.certification_type == '醫生' && val.isAgree == 1">
              <div
                class="user-poster"
                @click.stop="showUserPoster(val.uid)"
              ></div>
              <div :style="{ color: 'rgb(72,173,241)' }">推广码</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <div class="auth-confirm" v-if="isShowConfirm">
      <div class="gantanhao">!</div>
      <div class="word">{{ confirmText }}</div>
      <div class="confirm-btns">
        <div class="yes" @click.stop="doYes">是的</div>
        <div class="no" @click.stop="doCancel">让我再考虑一下...</div>
      </div>
    </div>
    <div class="mask" v-if="isShowConfirm" @click.stop="doCancel"></div>
  </div>
</template>
<script>
import {
  getDoctorList,
  doctorAuditNoPass,
  doctorAuditPass
} from "../../../../api/user";
import Loading from "@components/moblie/Loading";
import { mapGetters } from "vuex";
export default {
  name: "PromoterList",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      screen: {
        page: 1,
        limit: 5,
        type: 1
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      loadTitle: "",
      first: "",
      second: "",
      third: "",
      four: "",
      five: "",
      confirmText: "您确定要审核不通过吗？",
      isShowConfirm: false,
      currentUID: ""
    };
  },
  mounted: function() {
    this.getSpreadUsers();
    this.$scroll(this.$refs.container, () => {
      console.log("1");
      !this.loading && this.getSpreadUsers();
    });
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  watch: {
    $route(to, from) {
      if (from.path == "/user/doctor_list") {
        this.screen.page = 0;
        this.loaded = false;
        this.loading = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
      //this.reload()
    }
  },
  methods: {
    changUrl: function(val) {
      // 需过滤医生角色
      if (val.certification_type !== "患者" && this.screen.grade == 0) {
        var uid = val.uid;
        var certification_type = this.userInfo.certification_type;
        //console.log(certification_type)
        this.$router.push({
          //核心语句
          path: "/user/doctor_data", //跳转的路径
          query: {
            //路由传参时push和query搭配使用 ，作用时传递参数
            id: uid,
            certification_type: certification_type,
            grade: this.screen.grade
          }
        });
      } else if (this.screen.grade > 0) {
        this.$router.push(
          `/user/promote_router?certification_type=${this.screen.grade}&uid=${
            val.uid
          }`
        );
      }
    },
    doOpenConfirm(uid) {
      this.confirmText =
        this.screen.type == 1 ? "您确定审核不通过？" : "您确定审核通过？";
      this.isShowConfirm = true;
      this.currentUID = uid;
    },
    doCancel() {
      this.isShowConfirm = false;
      this.currentUID = "";
    },
    doYes() {
      if (this.screen.type == 1) {
        doctorAuditNoPass({ uid: this.currentUID }).then(res => {
          console.log(res);
          this.currentUID = "";
          this.isShowConfirm = false;
          this.screen.page = 1;
          this.loading = false;
          this.loaded = false;
          this.spreadList = [];
          this.getSpreadUsers();
        });
      } else {
        doctorAuditPass({ uid: this.currentUID }).then(res => {
          console.log(res);
          this.currentUID = "";
          this.isShowConfirm = false;
          this.screen.page = 1;
          this.loading = false;
          this.loaded = false;
          this.spreadList = [];
          this.getSpreadUsers();
        });
      }
    },
    // handleScroll: function() {
    //   var scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   var offsetTop = document.querySelector(".header").clientHeight;
    //   if (scrollTop >= offsetTop) {
    //     this.fixedState = true;
    //   } else {
    //     this.fixedState = false;
    //   }
    // },
    // submitForm: function() {
    //   this.screen.page = 0;
    //   this.loaded = false;
    //   this.loading = false;
    //   this.spreadList = [];
    //   this.getSpreadUsers();
    // },
    getSpreadUsers: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getDoctorList(screen).then(
        res => {
          that.loading = false;
          that.spreadList.push.apply(that.spreadList, res.data);
          that.loaded = res.data.length < that.screen.limit; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底線的" : "上拉加載更多";
          that.screen.page = that.screen.page + 1;
          console.log(that.spreadList);
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    checkGrade: function(val) {
      if (val == this.screen.type) return;
      else {
        this.screen.page = 1;
        this.screen.type = val;
        this.loading = false;
        this.loaded = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
    },
    sort: function(types) {
      let that = this;
      switch (types) {
        case "childCount":
          if (that.childCount == 2) {
            that.childCount = 1;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount DESC";
          } else if (that.childCount == 1) {
            that.childCount = 3;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount ASC";
          } else if (that.childCount == 3) {
            that.childCount = 2;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "";
          }
          break;
        case "numberCount":
          if (that.numberCount == 2) {
            that.numberCount = 1;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount DESC";
          } else if (that.numberCount == 1) {
            that.numberCount = 3;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount ASC";
          } else if (that.numberCount == 3) {
            that.numberCount = 2;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        case "orderCount":
          if (that.orderCount == 2) {
            that.orderCount = 1;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount DESC";
          } else if (that.orderCount == 1) {
            that.orderCount = 3;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount ASC";
          } else if (that.orderCount == 3) {
            that.orderCount = 2;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        default:
          that.screen.sort = "";
      }
    },
    showUserPoster(uid) {
      this.$router.push({
        path: `/user/poster?uid=${uid}`
      });
    },
    viewDetail(uid) {
      this.$router.push(`/user/group_number/${uid}`);
    },
    viewSales(uid) {
      this.$router.push(`/user/group_order/${uid}`);
    },
    viewOrders(uid) {
      this.$router.push(`/user/group_orders/0/${uid}`);
    }
  }
};
</script>
<style lang="scss" scoped>
.border-red {
  border-color: red;
}
.no-pass {
  background-color: lightgray;
  padding: 0.1rem;
  border-radius: 15px;
  color: #fff;
}
.do-pass {
  background-color: red;
  padding: 0.1rem;
  border-radius: 15px;
  color: #fff;
}
.person-bottom {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.2rem;
  &-item {
    margin-right: 0.3rem;
  }
}
.auth-confirm {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  transform: translateX(-50%);
  padding: 0.4rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 0 10px 0 lightgray;
  z-index: 99;
  .gantanhao {
    color: rgb(250, 206, 168);
    border-radius: 50%;
    border: 2px solid rgb(250, 206, 168);
    width: 1rem;
    height: 1rem;
    box-sizing: border-box;
    text-align: center;
    font-size: 0.7rem;
    line-height: 1rem;
  }
  .word {
    font-weight: 700;
    font-size: 0.4rem;
    margin: 0.2rem 0;
  }
  .confirm-btns {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.3rem;
    color: #fff;
    .yes {
      background-color: rgb(221, 107, 85);
      padding: 0.1rem 0.2rem;
      border-radius: 4px;
    }
    .no {
      background-color: rgb(170, 170, 170);
      padding: 0.1rem 0.2rem;
      border-radius: 4px;
    }
  }
}
.mask {
  background-color: #000;
  opacity: 0.3;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 5;
}
</style>
